import { useSelector } from 'react-redux';
import {
  getLanguage,
  getLanguageCode,
  getUrlCode,
  getSavedLanguage,
} from '@app/redux/localization/selectors';
import useUrlPrefix from '@app/hooks/useUrlPrefix';

interface UseLocalizationConfig {
  urlPrefix: string;
  langCode: string;
  urlCode: string;
  language: string;
  savedLanguage: string;
}

const useLocalization = (): UseLocalizationConfig => {
  const urlPrefix = useUrlPrefix();

  return useSelector((state) => ({
    urlPrefix,
    langCode: getLanguageCode(state),
    urlCode: getUrlCode(state),
    language: getLanguage(state),
    savedLanguage: getSavedLanguage(state),
  }));
};

export default useLocalization;
